window._ = require('lodash')

window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.$ = window.jQuery = require('jquery')
window.inputmask = require('inputmask/dist/jquery.inputmask')